// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License. See License.txt in the project root for license information.
export var BaseResourceMapper = {
  serializedName: "BaseResource",
  type: {
    name: "Composite",
    className: "BaseResource",
    modelProperties: {}
  }
};